import { Link } from "react-router-dom";

export const LogoMark = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="var(--ab-accent)" />
    <path d="M20 46 C20 30 30 18 46 18 C46 34 36 46 20 46 Z" fill="#FAFAF8" />
    <path d="M20 46 C28 38 34 32 42 22" stroke="var(--ab-accent)" strokeWidth="2.5" strokeLinecap="round" fill="none" />
    <rect x="16" y="44" width="30" height="3" rx="1.5" fill="#E9F3EC" />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="header-logo-link" aria-label="ArticleBlogs home">
    <LogoMark />
    <span className="font-serif text-xl font-semibold tracking-tight text-ab-text">
      Article<span className="text-ab-accent">Blogs</span>
    </span>
  </Link>
);
